/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';
import Spin from 'antd/lib/spin';
import { useParams } from 'react-router-dom';
import {
  getRecentIncidents,
  getEventsList,
  getEventFilterOptions,
  getAlertResolutionsList,
} from 'parity-network-requests';
import { ActiveAlertsTable } from './components/ActiveAlertsTable';
import { ResolvedAlertsTable } from './components/ResolvedAlertsTable';
import { config } from '../../../../config';

// ICONS
import { CheckmarkIcon } from '../CheckmarkIcon';

// IMAGES
import noAlerts from '../../../../images/no-alerts.png';
import alertsNotSetupLight from '../../../../images/alerts-not-setup-light.png';
import alertsNotSetupDark from '../../../../images/alerts-not-setup-dark.png';

import './AlertsOverview.less';

const { REACT_APP_BUILD_ENV } = config;

export const AlertsOverview = (props) => {
  const { theme, buildingName } = props;
  const { building } = useParams();
  const [alertsSetup, setAlertsSetup] = useState(false);
  const [activeEvents, setActiveEvents] = useState([]);
  const [resolvedEvents, setResolvedEvents] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [resolutionOptions, setResolutionOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    const incidentsList = await getRecentIncidents(REACT_APP_BUILD_ENV, building);
    setAlertsSetup(incidentsList.alerts_setup);
    const filterOptionsFromApi = await getEventFilterOptions(REACT_APP_BUILD_ENV, building);
    const resolutionOptionsFromApi = await getAlertResolutionsList(REACT_APP_BUILD_ENV, false);
    const activeEventsFromApi = await getEventsList(REACT_APP_BUILD_ENV, building, { is_resolved: false });
    const resolvedEventsFromApi = await getEventsList(REACT_APP_BUILD_ENV, building, { is_resolved: true });
    setFilterOptions(filterOptionsFromApi);
    setResolutionOptions(resolutionOptionsFromApi);
    setActiveEvents(activeEventsFromApi.results);
    setResolvedEvents(resolvedEventsFromApi.results);
  };

  useEffect(() => {
    fetchData();
    window.document.title = `${buildingName} | Alerts Overview`;
    setIsLoading(false);
  }, [building]);

  const renderAlertsNotSetup = () => {
    return (
      <div className="alerts-overview-no-alerts">
        {theme === 'light' ? (
          <img className="alerts-not-setup-image" src={alertsNotSetupLight} alt="alerts-not-setup" />
        ) : (
          <img className="alerts-not-setup-image" src={alertsNotSetupDark} alt="alerts-not-setup" />
        )}
        <div className="alerts-overview-no-alerts-heading">
          You will start getting notified of issues once your building is fully set up
        </div>
        <div className="alerts-overview-no-alerts-text">Current issues for this building may not be displayed</div>
      </div>
    );
  };

  const renderNoAlerts = () => {
    return (
      <div className="alerts-overview-no-alerts">
        <img className="no-alerts-image" src={noAlerts} alt="no-alerts" />
        <div className="alerts-overview-no-alerts-heading">Good news! Nothing needs your attention right now</div>
        <div className="alerts-overview-no-alerts-text">
          We will alert you when there are problems with your building
        </div>
      </div>
    );
  };

  const renderAlerts = () => {
    return (
      <>
        {!activeEvents.length ? (
          <div className="alerts-overview-no-active-alerts">
            <div className="alerts-overview-no-active-alerts-icon">
              <CheckmarkIcon theme="green" />
            </div>
            <div className="alerts-overview-no-active-alerts-content">
              <div className="alerts-overview-no-active-alerts-title">
                <strong>Good news!</strong>
                <span>Nothing needs your attention right now.</span>
              </div>
              <span>We will alert you when there are problems happening with your building!</span>
            </div>
          </div>
        ) : (
          <ActiveAlertsTable
            activeEvents={activeEvents}
            updateActiveEvents={(updatedEvents) => setActiveEvents(updatedEvents)}
            theme={theme}
          />
        )}
        <ResolvedAlertsTable
          resolvedEvents={resolvedEvents}
          updateResolvedEvents={(updatedEvents) => setResolvedEvents(updatedEvents)}
          filterOptions={filterOptions}
          resolutionOptions={resolutionOptions}
          theme={theme}
        />
      </>
    );
  };

  return (
    <div className={`alerts-overview-wrapper alerts-overview-wrapper-${theme}`}>
      {isLoading ? (
        <div className="alerts-overview-card">
          <div className="alerts-overview-card--loading">
            <Spin />
          </div>
        </div>
      ) : (
        <>
          {!alertsSetup ? (
            renderAlertsNotSetup()
          ) : (
            <>{!activeEvents.length && !resolvedEvents.length ? renderNoAlerts() : renderAlerts()}</>
          )}
        </>
      )}
    </div>
  );
};
